'use client';

import { c as _c } from "react/compiler-runtime";
import { cn } from '@module/lib/utils';
import useChatPanelStore from '@module/stores/useChatPanelStore';
import { useFetchLivePlayMutationStore } from '@module/stores/useFetchLivePlayMutationStore';
import useOldPlayerStore from '@module/stores/useOldPlayerStore';
import type { TabList } from '@module/types/broadcast-setting/type';
import ChatPanelButton from '@pc/components/atoms/button/ChatPanelButton';
import ChatContainer from '@pc/components/play/chat-area/chat/ChatContainer';
import ViewerRankListContainer from '@pc/components/play/chat-area/fan-rank/ViewerRankListContainer';
import ViewerListContainer from '@pc/components/play/chat-area/viewer/ViewerListContainer';
import { useState } from 'react';
const castList = [{
  title: '채팅',
  value: 'chat',
  id: 'chat-list-view-button'
}, {
  title: '시청자',
  value: 'viewer',
  id: 'viewer-list-view-button'
}, {
  title: '열혈팬',
  value: 'rank',
  id: 'viewer-rank-list-view-button'
}];
function PlayerSidePanel() {
  const $ = _c(36);
  const playInfo = useFetchLivePlayMutationStore(_temp);
  const isOpenChatPanel = useChatPanelStore(_temp2);
  const isPlayerFullscreen = useOldPlayerStore(_temp3);
  const [stepType, setStepType] = useState("chat");
  const [chatInputValue, setChatInputValue] = useState("");
  const isRoomMaster = !!playInfo?.fan?.isRoomMaster;
  const isManager = !!playInfo?.fan?.isManager;
  if (!isOpenChatPanel) {
    return null;
  }
  const t0 = isPlayerFullscreen && "top-0";
  let t1;
  if ($[0] !== t0) {
    t1 = cn("fixed top-16 right-0 bottom-0 z-20 w-[340px] border-borderBg01 border-l bg-white", t0);
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="absolute top-[-1px] left-[-43px] z-10 h-[42px] w-[42px]"><ChatPanelButton behavior="close" /></div>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== isManager || $[4] !== isRoomMaster || $[5] !== playInfo || $[6] !== stepType) {
    t3 = castList.map(item => {
      const clickDisabled = item.value === "chat" && !playInfo || item.value === "viewer" && !playInfo;
      if (item.value === "viewer" && !(isRoomMaster || isManager)) {
        return;
      }
      return <button data-gtm-chat-panel-tab={item.value} key={item.id} className={cn("h-full flex-1 border-0 text-center font-normal text-colorFg21 text-sm", stepType === item.value && "relative font-medium text-baseFg after:absolute after:bottom-[-1px] after:left-0 after:h-[2px] after:w-full after:bg-borderBg04 after:content-['']")} onClick={() => setStepType(item.value as TabList)} disabled={clickDisabled}>{item.title}</button>;
    });
    $[3] = isManager;
    $[4] = isRoomMaster;
    $[5] = playInfo;
    $[6] = stepType;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== t3) {
    t4 = <div className="flex h-[42px] w-full items-center justify-between border-borderBg01 border-b">{t3}</div>;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== chatInputValue || $[11] !== isManager || $[12] !== isRoomMaster || $[13] !== playInfo || $[14] !== stepType) {
    t5 = stepType === "chat" && playInfo && <ChatContainer playInfo={playInfo} isRoomMaster={isRoomMaster} isManager={isManager} setStepType={setStepType} chatInputValue={chatInputValue} setChatInputValue={setChatInputValue} />;
    $[10] = chatInputValue;
    $[11] = isManager;
    $[12] = isRoomMaster;
    $[13] = playInfo;
    $[14] = stepType;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  let t6;
  if ($[16] !== isManager || $[17] !== isRoomMaster || $[18] !== playInfo || $[19] !== stepType) {
    t6 = stepType === "viewer" && playInfo && <ViewerListContainer playInfo={playInfo} isRoomMaster={isRoomMaster} isManager={isManager} setStepType={setStepType} />;
    $[16] = isManager;
    $[17] = isRoomMaster;
    $[18] = playInfo;
    $[19] = stepType;
    $[20] = t6;
  } else {
    t6 = $[20];
  }
  let t7;
  if ($[21] !== isManager || $[22] !== isRoomMaster || $[23] !== playInfo || $[24] !== stepType) {
    t7 = stepType === "rank" && <ViewerRankListContainer playInfo={playInfo} isManager={isManager} isRoomMaster={isRoomMaster} />;
    $[21] = isManager;
    $[22] = isRoomMaster;
    $[23] = playInfo;
    $[24] = stepType;
    $[25] = t7;
  } else {
    t7 = $[25];
  }
  let t8;
  if ($[26] !== t5 || $[27] !== t6 || $[28] !== t7) {
    t8 = <div className="min-h-0 w-full flex-1 overflow-y-auto overflow-x-hidden">{t5}{t6}{t7}</div>;
    $[26] = t5;
    $[27] = t6;
    $[28] = t7;
    $[29] = t8;
  } else {
    t8 = $[29];
  }
  let t9;
  if ($[30] !== t4 || $[31] !== t8) {
    t9 = <div className="relative h-full">{t2}<div className="flex h-full w-[340px] flex-col bg-baseBg">{t4}{t8}</div></div>;
    $[30] = t4;
    $[31] = t8;
    $[32] = t9;
  } else {
    t9 = $[32];
  }
  let t10;
  if ($[33] !== t1 || $[34] !== t9) {
    t10 = <aside id="chatting_zone" className={t1} data-testid="play-chat">{t9}</aside>;
    $[33] = t1;
    $[34] = t9;
    $[35] = t10;
  } else {
    t10 = $[35];
  }
  return t10;
}
function _temp3(state_1) {
  return state_1.isPlayerFullscreen;
}
function _temp2(state_0) {
  return state_0.isChatPanelOpen;
}
function _temp(state) {
  return state.data;
}
export default PlayerSidePanel;